import {Row} from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const BannerButton = styled.button`
    display: block;
    width: 100%;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
`;

export const BannerImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;
